import { render, staticRenderFns } from "./WorkoutTemplate.vue?vue&type=template&id=e3528164&"
import script from "./WorkoutTemplate.vue?vue&type=script&lang=js&"
export * from "./WorkoutTemplate.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports